import { ThemeOptions } from '@mui/material';

import { baseTheme } from './base-theme';

export const lightTheme: ThemeOptions = {
  ...baseTheme,
};
